import { jwtDecode } from 'jwt-decode';
import { env } from 'config/env';
import {
  getAccessToken,
  clearAccessToken,
  isAccessTokenExpired,
} from './tokenStore';

export const getToken = () => getAccessToken();

// Zitadel owns the token lifecycle now; legacy setters are no-ops.
export const setToken = () => {};
export const removeToken = () => clearAccessToken();

export const isTokenExpired = () => isAccessTokenExpired();

// Optionally takes an explicit token (e.g. the reactive `auth.user.access_token`
// from react-oidc-context) — the in-memory store default is NOT reactive and is
// filled by TokenSync's effect, i.e. one render LATER than auth state settles.
export const getUserFromToken = (token = getAccessToken()) => {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

// Project-scoped Zitadel roles from the access token. The claim value is a map
// of { roleKey: { orgId: orgDomain } }; we return just the role keys. Returns []
// when there's no token or no roles claim. Reading roles here (rather than the
// single `role` string from /api/me) is multi-role-safe.
export const getProjectRoles = (token) => {
  const claims = getUserFromToken(token);
  if (!claims) return [];
  const map = claims[`urn:zitadel:iam:org:project:${env.oidc.projectId}:roles`];
  return map && typeof map === 'object' ? Object.keys(map) : [];
};
